exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-tab-filter{\n  padding:.5rem 1rem;\n  border-radius:25px;\n  margin-right:1rem;\n  margin-bottom:1.5rem;\n  background:#fff;\n  cursor:pointer\n}", ""]);

// exports
